module.exports = __webpack_public_path__ + "img/ic-layouts.1d480a69.svg";